import { gql } from '@/service/gql'
import { type SanitizedResult } from '@amzn/amp-gql'
// language=GraphQL
export const playParamsFrag = gql(`
    fragment playParams on PlayParams @_unmask {
        id
        containerIds
        selections
    }
`)

export type PlayParams = SanitizedResult<typeof playParamsFrag>
